<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Access Permission" subTitle="Forms" />

    <CreateAccessPermission />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateAccessPermission from "@/components/Pages/Master/AccessPermission/CreateAccessPermission.vue";

export default defineComponent({
  name: "CreateAccessPermissionPage",
  components: {
    PageTitle,
    CreateAccessPermission,
  },
});
</script>
